import { ArrowDropDown } from '@mui/icons-material';
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  Menu,
  MenuItem,
} from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { ModalComponent } from '../../../widgets';
import BotonComponent from '../../dashboard/components/BotonNuevo';
import { setActivoUsuariosAction } from '../../usuario/usuarios/UsuariosAction';
import FormNuevoUsuariosComponent from '../../usuario/usuarios/components/FormNuevoUsuarios';
import SelectFieldSeccionesComponent from '../secciones/components/SelectFieldSecciones';
import {
  allEstudiantesAction,
  setActivoEstudiantesAction,
} from './EstudiantesAction';
import { SELECTS_ESTUDIANTES } from './EstudiantesReducer';
import TodosCarnetsEstudiantes from './TodosCarnetsEstudiantes';
import ListadoEstudiantes from './components/ListadoEstudiantes';
import ReportesEstudiantes from './reportes/ReportesEstudiantes';

const EstudiantesView = () => {
  const dispatch = Redux.useDispatch();

  const loginStore = Redux.useSelector((state) => state.login);
  const estudiantesStore = Redux.useSelector((state) => state.estudiantes);
  const seccionesStore = Redux.useSelector((state) => state.secciones);
  const entidadesStore = Redux.useSelector((state) => state.entidades);

  const [openModalForm, setOpenModalForm] = React.useState(false);
  const [openModalReporte, setOpenModalReporte] = React.useState(false);
  const [seccionSelected, setSeccionSelected] = React.useState(null);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [modalCarnets, setModalCarnets] = React.useState(false);

  // generar carnet y codigo qr
  const [tipoCarnet, setTipoCarnet] = React.useState(null);

  React.useEffect(() => {
    if (estudiantesStore.params.idSeccion) {
      const seccionFind = seccionesStore.all.find(
        (el) => el.id === estudiantesStore.params.idSeccion,
      );
      setSeccionSelected(seccionFind);
    } else {
      setSeccionSelected(null);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [estudiantesStore.params.idSeccion]);

  const isNew =
    loginStore.isAdminTeacher || loginStore.isAdmin || loginStore.isRoot;

  return (
    <Grid container spacing={1} sx={{ position: 'relative' }}>
      <Grid
        item
        md={12}
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <Box>
          {isNew && estudiantesStore.params.idSeccion && (
            <BotonComponent
              click={async () => {
                await setActivoEstudiantesAction(dispatch, null);
                await setActivoUsuariosAction(dispatch, null);
                setOpenModalForm(true);
              }}
              green
              text={loginStore.isAdminTeacher ? 'ASIGNAR' : null}
              mr={2}
              addIcon
            />
          )}

          <BotonComponent
            click={async () => {
              await setActivoEstudiantesAction(dispatch, null);
              await allEstudiantesAction(dispatch, estudiantesStore.params);
            }}
            disabled={estudiantesStore.loadingAll}
            white
            refreshIcon
            text={
              estudiantesStore.loadingAll ? 'Actualizando...' : 'Actualizar'
            }
            mr={2}
          />
          {loginStore.isRoot && (
            <Box sx={{ display: 'inline-block', mr: 2 }}>
              <Button
                variant="contained"
                color="primary"
                onClick={(event) => setAnchorEl(event.currentTarget)}
                size="small"
              >
                Generar
                <ArrowDropDown />
              </Button>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(null)}
              >
                <MenuItem
                  onClick={() => {
                    // Code to generate carnet
                    setAnchorEl(null);
                    setTipoCarnet('carnet');
                    if (estudiantesStore.selects.length === 0) {
                      alert('Falta seleccionar los estudiantes');
                      return;
                    }
                    setModalCarnets(!modalCarnets);
                  }}
                >
                  Carnet
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    // Code to generate QR code
                    setAnchorEl(null);
                    setTipoCarnet('qrCode');
                    if (estudiantesStore.selects.length === 0) {
                      alert('Falta seleccionar los estudiantes');
                      return;
                    }

                    setModalCarnets(!modalCarnets);
                  }}
                >
                  Código QR
                </MenuItem>
              </Menu>
            </Box>
          )}
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <SelectFieldSeccionesComponent
            id="filtroSecciones"
            value={estudiantesStore.params.idSeccion}
            idsIgnore={[1, 2]}
            width="380px"
            onChange={(idSeccion) => {
              allEstudiantesAction(dispatch, {
                idSeccion,
                idEntidad: entidadesStore.activo.id,
              });
            }}
          />
        </Box>
      </Grid>
      <Grid item md={12}>
        <ListadoEstudiantes setOpenModalForm={(val) => setOpenModalForm(val)} />
      </Grid>
      {/* <DrawerWidget open={isFiltros} onClose={(val) => setIsFiltros(val)}>
        <FiltrosEstudiantesComponent />
      </DrawerWidget> */}
      <ModalComponent
        id="modalFormEstudiantes"
        title="Nuevo estudiante"
        open={openModalForm}
        maxWidth="lg"
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        {seccionSelected && (
          <Alert variant="filled" severity="info">
            Automaticamente se creará la matrícula del estudiante y será
            asignado en el <strong>Nivel académico:</strong>{' '}
            {seccionSelected.nivelAcademico.nivelAcademico.nombre} en la{' '}
            <strong>seccion:</strong> {seccionSelected.nombre}
          </Alert>
        )}

        <FormNuevoUsuariosComponent
          activo={estudiantesStore.activo}
          setOpenModalForm={(val) => setOpenModalForm(val)}
          isUsuarios={false}
          isPerfiles={false}
          isStudent
          idSeccion={estudiantesStore.params.idSeccion}
        />
      </ModalComponent>
      <ModalComponent
        id="modalPdf"
        title="Reporte de estudiantes"
        open={openModalReporte}
        maxWidth="lg"
        onClose={() => setOpenModalReporte(!openModalReporte)}
      >
        <ReportesEstudiantes />
      </ModalComponent>
      <ModalComponent
        id="modal-carnets-codeqr"
        title={`Descargar ${tipoCarnet === 'carnet' ? 'Carnet' : 'Códigos QR'}`}
        open={loginStore.isRoot && modalCarnets}
        maxWidth="xl"
        onClose={() => setModalCarnets(!modalCarnets)}
      >
        <TodosCarnetsEstudiantes tipoCarnet={tipoCarnet} />
      </ModalComponent>

      {estudiantesStore.selects.length > 0 && !modalCarnets && (
        <Box
          sx={{
            position: 'fixed',
            bottom: 24,
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 1500,
            width: '340px',
          }}
        >
          <Card
            variant="outlined"
            sx={{
              width: '100%',
              boxShadow: 3,
            }}
          >
            <CardContent
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: 2,
              }}
            >
              Selec.: {estudiantesStore.selects.length}
              {/* generar carnets y qr code */}
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  setModalCarnets(!modalCarnets);
                }}
              >
                Generar
              </Button>
              {/* limpiar seleccion */}
              <Button
                variant="contained"
                color="secondary"
                onClick={() => {
                  dispatch({ type: SELECTS_ESTUDIANTES, payload: [] });
                }}
              >
                Limpiar
              </Button>
            </CardContent>
          </Card>
        </Box>
      )}
    </Grid>
  );
};

export default EstudiantesView;
